import React from 'react';
import CustomPaper from "./../../shared/utils/CustomPaper";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import RaisedButton from "material-ui/RaisedButton";
import SalarieService from "../services/SalarieService";
import {getInfosSalarie} from "../../../actions/salarie/actions_salarie_1";

export default class InfosPersosSalarie extends React.Component {
    constructor(props) {
        super(props);
        this.state = {email: this.props.email, budget_cpf: this.props.budget_cpf};
        this.salarieService = new SalarieService();
    }

    render() {
        return (
            <div className={'container'} style={{fontSize: 12}}>
                <CustomPaper title={'Informations personnelles'}>
                    <ValidatorForm
                        ref="form"
                        onSubmit={() =>
                            this.salarieService.editSalarieInfos({
                                email: this.state.email,
                                budget_cpf: this.state.budget_cpf
                            })
                                .then(() => {
                                    this.props.dispatch(getInfosSalarie());
                                    window.alert("Modifications prises en compte");
                                })
                        }
                    >
                        <TextValidator
                            value={this.state.email}
                            onChange={(x, y) => this.setState({email: y})}
                            fullWidth={true}
                            name='email'
                            type="email"
                            validators={['required', 'isEmail']}
                            errorMessages={['Ce champs est obligatoire', 'Format incorrect.']}
                            floatingLabelText="Email du salarié"
                        /><br/>
                        <TextValidator
                            value={this.state.budget_cpf}
                            onChange={(x, y) => this.setState({budget_cpf: Number(y)})}
                            fullWidth={true}
                            name="budget_cpf"
                            type="number"
                            validators={['required']}
                            errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                            floatingLabelText="Budget CPF mobilisable (euros)"
                        /><br/>
                        <RaisedButton
                            type="submit"
                            label="Modifier"
                        />
                    </ValidatorForm>
                </CustomPaper>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/salarie/bodies/InfosPersosSalarie.js